export default __webpack_public_path__ + "static/media/bathroom-Up_W113EI90.d76dcf89.jpg";